export default __webpack_public_path__ + "static/media/goblin.7b3c2670.jpg";